<template>
	<div class="hit-row" v-bind:key="login_key">
		<div class="hit-col-md-6 hit-col-md-hit-offset-3">

			<div class="hit-panel hit-panel-primary hit-html-html">
				<div class="hit-panel-heading">
					{{ $t('message.signIn') }}
				</div>
				<div class="hit-panel-body" v-if="!$store.getters.user">
					<loginForm :settings="{ onSubmit: function(data){ onSubmit(data); }, getError: function(){ return getError(); }}"/>
				</div>

				<div class="hit-panel-body" v-if="$store.getters.user">
					<div class="hit-form-group">
						<router-link class="hit-btn hit-btn-default hit-btn-block" :to="{ name: 'app', params: {lang: $store.getters.lang} }">{{ $t('message.goTo', {name: $t('message.dashboard')}) }}</router-link>
					</div>
					<div class="hit-form-group">
						<router-link class="hit-btn hit-btn-default hit-btn-block" :to="{ name: 'logout', params: {lang: $store.getters.lang} }">{{ $t('message.logout') }}</router-link>
					</div>
				</div>

				<div class="hit-panel-footer">
						<div class="hit-pull-right">
							<router-link v-if="!$store.getters.user" class=" hit-html-a" :to="{ name: 'forgot_password', params: {lang: $store.getters.lang} }">{{ $t('message.forgotPassword') }}</router-link>
						</div>
						<router-link class="hit-html-a" :to="{ name: 'sign_up', params: {lang: $store.getters.lang} }">{{ $t('message.signUp') }}</router-link>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import loginForm from '@core/components/content/login_form'

export default{
  name: 'sign_in',
  components: {loginForm},
  data () {
    return {
      error: false,
      login_key: new Date().getTime()
    }
  },

  methods: {

    getError: function () {
      return this.error
    },
    onSubmit: function (data) {
      var send = {
        username: data.username,
        password: data.password
      }

      var my_class = this

      this.$hit_post({url: 'user/get_login',
        data: {login: btoa(send.username + ':' + send.password)},
        callback: function (ret) {
          if (ret.data[0]) {
            if (typeof ret.data[1].accent_color2 === 'undefined') { ret.data[1].accent_color2 = '#ffffff' }

            my_class.$store.commit('set_user', ret.data[1])
            my_class.is_logged_in = !my_class.is_logged_in

            return false
          } else {
            my_class.error = true
          }
        }})
			 },

    check_error: function () {
      var check = true

      Object.values(this.error).forEach(function (key) {
        if (key === true) {
          check = false
          return false
        }
      })

      return check
    }
  },
  metaInfo: function () {
	    return {
	     title: this.$t('message.signIn')
	   }
	 }
}
</script>
